module.exports = __webpack_public_path__ + "img/no_payment_subscription.0714df7d.svg";